import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { BlockedPhoneNumberRegisterComponent } from './containers/blocked-phone-number-register.component';
import { BlockedPhoneNumberRegisterEffects } from './state/blocked-phone-number-register.effects';
import {
   blockedPhoneNumberRegisterFeatureKey,
   blockedPhoneNumberRegisterReducer,
} from './state/blocked-phone-number-register.reducer';
import { BlockedPhoneNumberRegisterViewComponent } from './views/blocked-phone-number-register-view.component';

@NgModule({
   declarations: [BlockedPhoneNumberRegisterComponent, BlockedPhoneNumberRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      RegisterModule,
      ScrollingModule,
      FormatPhoneNumbersPipeModule,
      EffectsModule.forFeature([BlockedPhoneNumberRegisterEffects]),
      StoreModule.forFeature(blockedPhoneNumberRegisterFeatureKey, blockedPhoneNumberRegisterReducer),
   ],
})
export class BlockedPhoneNumberRegisterModule {}
